import React from 'react'

import { VideoContext } from "./../../context/VideoContext";

import './video.scss'

import { ReactComponent as Play } from './../../assets/play.svg';
import { ReactComponent as Pause } from './../../assets/pause.svg';
import posterPlaceholder from './../../assets/poster-placeholder.jpg'
// import posterTransparent from './../../assets/poster-transparent.png'
import posterTransparent from './../../assets/poster-small.gif'

export const Video = ( { file, poster, controls } ) => {
    const [ percentage, setPercentage ] = React.useState( 0 )
    const [ playing, setPlaying ] = React.useState( false )
    const [ hovering, setHovering ] = React.useState( false )
    const context = React.useContext( VideoContext );
    const videoRef = React.useRef()
    const hoverTimer = React.useRef()

    const previousUrl = React.useRef( file.url );

    const handlePause = () => {
        setPlaying( false )
    }

    const handleEnd = () => {
        videoRef.current.currentTime = 0
    }

    const handleTimeUpdate = () => {
        calcPercentage()
    }

    const calcPercentage = () => {
        setPercentage( videoRef.current.currentTime / videoRef.current.duration * 100 )
    }

    const togglePlay = () => {
        const stopVideo = () => {
            context.video.map( video => {
                !video.paused && video.pause()    

                return false
            } )
        }
        
        const play = () => {
            stopVideo()
            videoRef.current.play()
        }

        const pause = () => {
            videoRef.current.pause()
        }

        !playing
            ? play()
            : pause()

        setPlaying( !playing )
    }

    const toggleHovering = () => {
        setHovering( true )
        clearInterval( hoverTimer.current )
        hoverTimer.current = setTimeout( () => setHovering(false), 500 )
    }

    React.useEffect( () => {
        return clearInterval(hoverTimer.current )
    }, [] ) 

    React.useEffect(() => {
        if (previousUrl.current !== file.url && videoRef.current) {
            videoRef.current.load()
            previousUrl.current = file.url
            setPlaying( false )
            setPercentage( 0 )
        }
    }, [ file.url ]);

    return (
        <div className={ `video` } >
            <img className={ [ `video-poster` ].join( ` ` ) } src={ poster ? poster.sizes.large : posterPlaceholder } />
            <video 
                onPause={ handlePause } 
                onEnded={ handleEnd } 
                onTimeUpdate={ handleTimeUpdate } 
                onLoadedMetadata={ () => context.setVideo( [ ...context.video, videoRef.current] ) } 
                ref={ videoRef } 
                className={ [ `video-frame` ] } 
                poster={ posterTransparent }
                playsInline 
                preload={ `none` }
                nocontrols={ true.toString() } 
                style={ {
                    backgroundImage: `url(${ poster ? poster.sizes.large : posterPlaceholder })`,
                    backgroundSize: `cover`,
                    backgroundPosition: `center`
                } }
            >
                <source src={ file.url } type="video/mp4" /> 
                Your browser does not support the video tag.
            </video>
            <div className={ [ `video-progress`, `video-progress--${ playing ? `is-playing` : `not-playing` }` ].join( ` ` ) } style={ { width: `${ percentage }%` } } />
            <div 
                onMouseMove={ () => toggleHovering() } 
                className={ [ 
                    `video-controls`, 
                    `video-controls--${ controls === `white` ? `is-light` : `is-dark` }`, 
                    `video-controls--${ playing ? `is-playing` : `not-playing` }`,
                    `video-controls--${ hovering ? `is-hovering` : `not-hovering` }` 
                ].join( ` ` ) } 
                onClick={ () => togglePlay() } 
            >
                {
                    playing
                        ? <Pause />
                        : <Play />
                }
            </div>
        </div>
    )
}